export const setCompany = (company) => {
    return (dispatch) => {
        dispatch({
            type: "setCompany",
            payload: company
        });
    }
}

export const setCompanyInfo = (companyInfo) => {
    return (dispatch) => {
        dispatch({
            type: "setCompanyInfo",
            payload: companyInfo
        });
    } 
}

export const setTransactionDetails = (transactionDetails) => {
    return (dispatch) => {
        dispatch({
            type: "setTransactionDetails",
            payload: transactionDetails
        });
    } 
}

export const setUserSession = (userSession) => {
    return (dispatch) => {
        dispatch({
            type: "setUserSession",
            payload: userSession
        });
    } 
}

export const setBackPath = (backPath) => {
    return (dispatch) => {
        dispatch({
            type: "setBackPath", 
            payload: backPath
        });  
    }
}

export const setRebateSummarySearch = (rebateSummarySearch) => {
    return (dispatch) => {
        dispatch({
            type: "setRebateSummarySearch", 
            payload: rebateSummarySearch
        });  
    }
}

export const setRebateSummaryPeriod = (rebateSummaryPeriod) => {
    return (dispatch) => {
        dispatch({
            type: "setRebateSummaryPeriod", 
            payload: rebateSummaryPeriod
        });  
    }
}

export const setRebateFrequency = (rebateFrequency) => {
    return (dispatch) => {
        dispatch({
            type: "setRebateFrequency", 
            payload: rebateFrequency
        });  
    }
}

export const setWorkflowEligible = (workflowEligible) => {
    return (dispatch) => {
        dispatch({
            type: "setWorkflowEligible", 
            payload: workflowEligible
        });  
    }
}

export const setWorkflowStatus = (workflowStatus) => {
    return (dispatch) => {
        dispatch({
            type: "setWorkflowStatus", 
            payload: workflowStatus
        });  
    }
}

export const setCompanyProfileSearch = (companyProfileSearch) => {
    return (dispatch) => {
        dispatch({
            type: "setCompanyProfileSearch", 
            payload: companyProfileSearch
        });  
    }
}

export const setSubCompanySearch = (subCompanySearch) => {
    return (dispatch) => {
        dispatch({
            type: "setSubCompanySearch", 
            payload: subCompanySearch
        });  
    }
}

export const setAdhocPaymentSearch = (adhocPaymentSearch) => {
    return (dispatch) => {
        dispatch({
            type: "setAdhocPaymentSearch", 
            payload: adhocPaymentSearch
        });  
    }
}

export const setConsortiumSearch = (consortiumSearch) => {
    return (dispatch) => {
        dispatch({
            type: "setConsortiumSearch", 
            payload: consortiumSearch
        });  
    }
}

export const setContractSearch = (contractSearch) => {
    return (dispatch) => {
        dispatch({
            type: "setContractSearch", 
            payload: contractSearch
        });  
    }
}

export const setConsortiumId = (consortiumId) => {
    return (dispatch) => {
        dispatch({
            type: "setConsortiumId",
            payload: consortiumId, 
        });
    }
}

export const setRebatePortfolio2 = (rebatePortfolio2) => {
    return (dispatch) => {
        dispatch({
            type: "setRebatePortfolio2", 
            payload: rebatePortfolio2
        }); 
    }
}

export const setWorkflowType = (workflowType) => {
    return (dispatch) => {
        dispatch({
            type: "setWorkflowType", 
            payload: workflowType
        }); 
    }
}

export const setWorkflowIndicator = (workflowIndicator) => {
    return (dispatch) => {
        dispatch({
            type: "setWorkflowIndicator", 
            payload: workflowIndicator
        }); 
    }
}

export const setCompanyTypeFilter1 = (companyTypeFilter1) => {
    return (dispatch) => {
        dispatch({
            type: "setCompanyTypeFilter1", 
            payload: companyTypeFilter1
        }); 
    }
}

export const setRebatePortfolio1 = (rebatePortfolio1) => {
    return (dispatch) => {
        dispatch({
            type: "setRebatePortfolio1", 
            payload: rebatePortfolio1
        }); 
    }
}

export const setCompanyTypeFilter2 = (companyTypeFilter2) => {
    return (dispatch) => {
        dispatch({
            type: "setCompanyTypeFilter2", 
            payload: companyTypeFilter2
        }); 
    }
}

export const setCompanyTypeFilter3 = (companyTypeFilter3) => {
    return (dispatch) => {
        dispatch({
            type: "setCompanyTypeFilter3", 
            payload: companyTypeFilter3
        }); 
    }
}

export const setRebatePortfolio3 = (rebatePortfolio3) => {
    return (dispatch) => {
        dispatch({
            type: "setRebatePortfolio3", 
            payload: rebatePortfolio3
        }); 
    }
}

export const setFooterConfig = (footerConfig) => {
    return (dispatch) => {
        dispatch({
            type: "setFooterConfig",
            payload: footerConfig
        });
    }
}

export const setAttributes = (attributes) => {
    return (dispatch) => {
        dispatch({
            type: "setAttributes", 
            payload: attributes
        }); 
    }
}